import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _defaultMap;
import { useCallback, useEffect, useState } from 'react';
import { DIMENSION_TYPE } from "./types";
import { getStartPoints, mapping } from "./utils";
export var defaultMap = (_defaultMap = {}, _defineProperty(_defaultMap, DIMENSION_TYPE.MOBILE, 0), _defineProperty(_defaultMap, DIMENSION_TYPE.TABLET, 768), _defineProperty(_defaultMap, DIMENSION_TYPE.DESKTOP, 1024), _defaultMap);
export var useBreakpoints = function useBreakpoints() {
  var map = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultMap;
  var getMappedData = useCallback(function () {
    var _window$innerWidth, _window;
    return mapping((_window$innerWidth = (_window = window) === null || _window === void 0 ? void 0 : _window.innerWidth) !== null && _window$innerWidth !== void 0 ? _window$innerWidth : 0, map);
  }, []);
  var _useState = useState(getStartPoints(map)),
    _useState2 = _slicedToArray(_useState, 2),
    points = _useState2[0],
    setPoints = _useState2[1];
  useEffect(function () {
    var subscribe = function subscribe() {
      return setPoints(getMappedData());
    };
    subscribe();
    window.addEventListener('resize', subscribe);
    return function () {
      return window.removeEventListener('resize', subscribe);
    };
  }, []);
  return points;
};
export var useIsMobileDimension = function useIsMobileDimension(map) {
  return DIMENSION_TYPE.MOBILE === useBreakpoints(map)[0];
};
export var useIsTabletDimension = function useIsTabletDimension(map) {
  return DIMENSION_TYPE.TABLET === useBreakpoints(map)[0];
};
export var useIsDesktopDimension = function useIsDesktopDimension(map) {
  return DIMENSION_TYPE.DESKTOP === useBreakpoints(map)[0];
};